import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=8acbfd1c&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=8acbfd1c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acbfd1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8acbfd1c')) {
      api.createRecord('8acbfd1c', component.options)
    } else {
      api.reload('8acbfd1c', component.options)
    }
    module.hot.accept("./orderDetails.vue?vue&type=template&id=8acbfd1c&scoped=true", function () {
      api.rerender('8acbfd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/orderDetails.vue"
export default component.exports